import styled from 'styled-components';

const Container = styled.div`
  background: white;
  border-radius: 5px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`
const ItemContainer = styled.div`
  padding: 10px;
  width: 100%;

`
const Title = styled.p`
  font-weight: bold;
`
const SubTitle = styled.p`
`

const Remove = styled.a`
  color: red;
  margin: 0;
  margin-top: 10px;
  font-size: 10px;
  margin-right: 5px;

`

const Edit = styled.a`
  color: blue;
  margin: 0;
  margin-top: 10px;
  font-size: 10px;
  margin-right: 5px;
`

export {
  Container,
  ItemContainer,
  Title,
  SubTitle,
  Remove,
  Edit
}
